
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderBrandAmbassadorShareGrid extends Serenity.EntityGrid<OrderBrandAmbassadorShareRow, any> {
        protected getColumnsKey() { return OrderBrandAmbassadorShareColumns.columnsKey; }
        protected getDialogType() { return OrderBrandAmbassadorShareDialog; }
        protected getIdProperty() { return OrderBrandAmbassadorShareRow.idProperty; }
        protected getInsertPermission() { return OrderBrandAmbassadorShareRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderBrandAmbassadorShareRow.localTextPrefix; }
        protected getService() { return OrderBrandAmbassadorShareService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }
        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        /*protected getQuickFilters() {
            var filter = super.getQuickFilters();
            if (Authorization.hasPermission("Users:Franchisee") && !Authorization.hasPermission("Administration:Security")) {
                filter.splice(0, 2);
            }

            return filter;
        }*/

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: OrderBrandAmbassadorShareService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push({
                title: 'Brand Ambassador Payout',
                cssClass: 'print-button',
                onClick: () => {
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        Q.alert("Please select order first");
                        return;
                    }
                    else {
                        new BrandAmbassadorPayoutDialog(this, true, rowKeys.toString()).dialogOpen();
                    }
                }
            });

            return buttons;
        }
    }
}